import { BoardingTour } from './BoardingTour';

export default BoardingTour;
